import { Injectable, Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Pakbon } from '../dto/pakbon';
import { CrudService } from '@mango/core';
import { map } from 'rxjs/operators';
import { createFactuur } from '../dto/createfactuur';
import { DocumentDownloadResponse } from './projectregel.service';

@Injectable({ providedIn: 'root' })
export class PakbonService extends CrudService<Pakbon> {

    constructor(injector: Injector) { super(Pakbon, injector); }

    PakbonGenereren(pakbon: Pakbon) {
        let query: string = `api/dto/pakbon/PakbonGenereren?pakbonId=${pakbon.id}`;

        return this.http.post(query, null).pipe(map(x => x as PakbonResponse));

    }

    createFacturen(pakbonnen: Pakbon[], proforma: boolean) {

        var cf = new createFactuur();
        cf.pakbonnen = pakbonnen;
        cf.proforma = proforma;
    
        let query: string = `api/dto/factuur/createFactuur`;
    
        return this.http.post(query, cf).pipe(map(x => x as FactuurResponse));   
        
    }

    DownloadPakbon(id: number) {

        let query: string = `api/dto/projectregel/DownloadPakbon?pakbonId=${id}`;

        return this.http.post(query, null).pipe(map(x => x as DocumentDownloadResponse));
    }

}

export class PakbonResponse {
    successful: boolean;
    message: string;
}

export class FactuurResponse {
    successful: boolean;
    message: string;
}
